import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ThresholdContainer from '@components/noc-metric-panel/ThresholdV2';
import { refreshTable } from '@store/dimensionTables/actions';
import { ContentWrapper } from '../../styled';

function Content() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(refreshTable());
  }, []);

  return (
    <ContentWrapper>
      <ThresholdContainer />
    </ContentWrapper>
  );
}

export default Content;
